import { Box, Button, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import { WarningRounded} from "@mui/icons-material";
import api from "API/api";

const DeletePreferenceModal = ({
  setUserData,
  deltePreferenceOpen,
  setDeletePreferenceOpen,
}) => {
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const handleClose = () => {
    setDeletePreferenceOpen(false);
  };

  const handleDelete = async () => {
    try {
      const res = await api.delete(`/analytics/preferences`);
      let tempuser = user;
      tempuser.preferences = {};
      localStorage.setItem("user", JSON.stringify(tempuser));
      setUserData(tempuser);
      setDeletePreferenceOpen(false);

    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  return (
    <Modal open={deltePreferenceOpen} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          textAlign: "center",
          outline:'none'
        }}
        className="delete-scenario-modal"
      >
        <Box sx={{ marginBottom: "40px" }}>
          <Box sx={{ display: "flex" }}>
            <Typography
              color="error"
              sx={{
                background: "rgb(250 212 212)",
                width: "50px",
                height: "50px",
                borderRadius: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "4px",
              }}
            >
              <WarningRounded />
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                marginLeft: "12px",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontSize: "18px", marginBottom: "5px" }}
              >
                Delete Preference
              </Typography>
              <Typography sx={{ fontSize: "13px", color: "#9c9b9b" }}>
                Are you sure you want to delete this preference?
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
          <Button
            onClick={handleClose}
            sx={{
              textTransform: "none",
              width: "48%",
              border: "1px solid gray",
              color: "gray",
              fontWeight: "500",
              fontSize: "15px",
            }}
            variant="outlined"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              width: "48%",
              fontWeight: "500",
              fontSize: "15px",
              background: "#fc4f4f",
              color: "white !important",
              "&:hover": {
                background: "#fc4f4f",
                color: "white !important",
              },
            }}
            onClick={handleDelete}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeletePreferenceModal;
